import { Invoke } from '@swf/components/StarsWizard/Flow';
import type { FlowConfig } from '@swf/core/types/Wizard';

import RMFDepositLimit from '../../components/RMFDepositLimit/RMFDepositLimit';
import RMFLegalName from '../../components/RMFLegalName/RMFLegalName';
import RMFPhone from '../../components/RMFPhone/RMFPhone';
import RMFPlayerFundsProtection from '../../components/RMFPlayerFundsProtection/RMFPlayerFundsProtection';

import useRMFBaseSteps from './../useRMFBaseSteps';
import { Service } from './../useRmfServices';
import useRmfUKBaseSteps from './useRmfUKBaseSteps';

const useRmfUKPhoneAfterAddressFlow = (): FlowConfig => {
  const { jumpToFeatureStep, forkDobCheck, invokeSignupDob } = useRMFBaseSteps();
  const {
    forkVerification,
    invokeRetryEnableRealMoneyFlag,
    invokeDepositLimitSave,
    forkRetryScreen,
    invokeEnableRealMoneyFlag,
    invokeUserDataSave
  } = useRmfUKBaseSteps();

  const invokeMobilePhoneSave = new Invoke(Service.RmfMobilePhoneSave, RMFDepositLimit, RMFPhone);

  return [
    RMFLegalName,
    invokeSignupDob,
    forkDobCheck,
    RMFPhone,
    invokeMobilePhoneSave,
    RMFDepositLimit,
    invokeDepositLimitSave,
    RMFPlayerFundsProtection,
    invokeUserDataSave,
    invokeEnableRealMoneyFlag,
    forkRetryScreen,
    invokeRetryEnableRealMoneyFlag,
    forkVerification,
    jumpToFeatureStep
  ];
};

export default useRmfUKPhoneAfterAddressFlow;
